import { Injectable } from '@angular/core';

import { filter, first, lastValueFrom } from 'rxjs';
import {
  ConfigurationsPurchaseService,
  ConfigurationsSellService,
  ConfigurationsWithdrawalService,
} from '../abstract-services/configurations/configurations.service';
import { AbstractCrudService } from '../abstract/abstract-crud.service';
import {
  OperationTypes,
  PurchaseConfig,
} from '../purchase-manager/purchase-manager.service';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationsService {
  private configPurchaseSection = 'configurations-purchase';
  private configSellSection = 'configurations-sell';
  private configWithdrawSection = 'configurations-withdraw';

  configurationPurchase$ = this.configurationsPurchaseService
    .getObservable(this.configPurchaseSection)
    .pipe(
      filter(config => !!config),
      first()
    );

  configurationSell$ = this.configurationsSellService
    .getObservable(this.configSellSection)
    .pipe(
      filter(config => !!config),
      first()
    );

  configurationWithdraw$ = this.configurationsWithdrawService
    .getObservable(this.configWithdrawSection)
    .pipe(
      filter(config => !!config),
      first()
    );

  constructor(
    private configurationsPurchaseService: ConfigurationsPurchaseService,
    private configurationsSellService: ConfigurationsSellService,
    private configurationsWithdrawService: ConfigurationsWithdrawalService
  ) {}

  async getConfiguration(
    assetId: string,
    type: OperationTypes
  ): Promise<PurchaseConfig> {
    const configurationsService = {
      [OperationTypes.WITHDRAWAL]: this.configurationsWithdrawService,
      [OperationTypes.BUY]: this.configurationsPurchaseService,
      [OperationTypes.SELL]: this.configurationsSellService,
    };

    const serviceListener$ = {
      [OperationTypes.WITHDRAWAL]: this.configurationWithdraw$,
      [OperationTypes.BUY]: this.configurationPurchase$,
      [OperationTypes.SELL]: this.configurationSell$,
    };

    const section = {
      [OperationTypes.WITHDRAWAL]: this.configWithdrawSection,
      [OperationTypes.BUY]: this.configPurchaseSection,
      [OperationTypes.SELL]: this.configSellSection,
    };

    const configService: AbstractCrudService<any, any> =
      configurationsService[type];

    configService.getAll({}, [assetId], '', true, section[type]);

    const comissions = await lastValueFrom(serviceListener$[type] as any);
    return comissions as any;
  }
}
